import axios from "axios";
import { environment } from "../../environments/environment";
import { FeatureFlags, getCurrentEnvironment } from "../utils/environmentConfig";

export interface Banner {
  id: number;
  name: string;
  description: string;
  image: string;
  link: string | null;
  startDate: string;
  endDate: string;
  active: boolean;
  partnerCompany: number;
  partnerCompanyName: string;
  sector: number | null;
  sectorName: string | null;
  ctaText: string;
  displayFrequency: "once" | "daily" | "always";
  displayDelay: number;
  priority: number;
  viewsCount: number;
  clicksCount: number;
  conversionRate: number;
  isPopup: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Busca o popup ativo de maior prioridade
 * @returns Banner popup ativo ou null se não houver nenhum
 */
export const getActivePopup = async (): Promise<Banner | null> => {
  try {
    const response = await axios.get<Banner>(
      `${environment.apiUrl}/api/banners/active-popup/`
    );
    return response.data;
  } catch (error: any) {
    // 204 No Content significa que não há popup ativo no momento
    if (error.response?.status === 204) {
      return null;
    }
    // 404 significa que o setor Pop-up não foi configurado
    if (error.response?.status === 404) {
      console.warn("Setor Pop-up não configurado no backend");
      return null;
    }
    throw error;
  }
};

/**
 * Registra uma visualização do banner/popup
 * @param bannerId ID do banner
 */
export const trackBannerView = async (bannerId: number): Promise<void> => {
  // Só registrar visualizações em produção
  if (!FeatureFlags.enableAnalytics) {
    if (FeatureFlags.enableDebugLogs) {
      console.log(`[${getCurrentEnvironment()}] Visualização do banner ${bannerId} não registrada (analytics desabilitado)`);
    }
    return;
  }

  try {
    await axios.post(
      `${environment.apiUrl}/api/banners/${bannerId}/track_view/`
    );
  } catch (error) {
    console.error("Erro ao registrar visualização do banner:", error);
  }
};

/**
 * Registra um clique no banner/popup
 * @param bannerId ID do banner
 */
export const trackBannerClick = async (bannerId: number): Promise<void> => {
  // Só registrar cliques em produção
  if (!FeatureFlags.enableAnalytics) {
    if (FeatureFlags.enableDebugLogs) {
      console.log(`[${getCurrentEnvironment()}] Clique no banner ${bannerId} não registrado (analytics desabilitado)`);
    }
    return;
  }

  try {
    await axios.post(
      `${environment.apiUrl}/api/banners/${bannerId}/track_click/`
    );
  } catch (error) {
    console.error("Erro ao registrar clique no banner:", error);
  }
};

